export const SET_TOKEN = 'SET_TOKEN'
export const UNSET_TOKEN = 'UNSET_TOKEN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_PAGE_CLASS = 'SET_PAGE_CLASS'
export const SET_PRELOADER = 'SET_PRELOADER'
export const SET_SHOWMENU = 'SET_SHOWMENU'
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS'
export const SET_CITY_DETAILS = 'SET_CITY_DETAILS'
export const SET_UNIVERSITY_DETAILS = 'SET_UNIVERSITY_DETAILS'
export const SET_LOGIN_INFO_INFO = 'SET_LOGIN_INFO'
export const SET_MOBILE_MENU_ACTIVE = 'SET_MOBILE_MENU_ACTIVE'
export const SET_BLOG_CATEGORY_TITLE = 'SET_BLOG_CATEGORY_TITLE'
export const SET_BLOG_CATEGORY_SLUG = 'SET_BLOG_CATEGORY_SLUG'
